import React from 'react';
import styled from 'styled-components';
import ModalContent from '../ModalContent';
import PDFDocument from '../../PDFDocument';

interface PDFPreviewModalProps {
  closeModalHandler: VoidFunction;
}

const Content = styled(ModalContent)`
  height: 80%;
  overflow: auto;
  padding: 0;
`;

const PDFPreviewModal: React.FC<PDFPreviewModalProps> = ({ closeModalHandler }) => {
  return (
    <Content>
      <PDFDocument closeModalHandler={closeModalHandler} />
    </Content>
  );
};

export default PDFPreviewModal;
